import { render, staticRenderFns } from "./CreatorResolver.vue?vue&type=template&id=65d2b8e2&scoped=true&"
import script from "./CreatorResolver.vue?vue&type=script&lang=js&"
export * from "./CreatorResolver.vue?vue&type=script&lang=js&"
import style0 from "./CreatorResolver.vue?vue&type=style&index=0&id=65d2b8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2b8e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
